import React from 'react';

const CommentFormRow = ({ className, label, htmlFor, children }) => {
  return (
    <div className={`mt-[10px] ${className ? className : ''}`}>
      <label htmlFor={htmlFor} className="block">{label}</label>
      {children}
    </div>
  );
};

export default CommentFormRow;